import $paths from "@/constants/route-paths";
import { appConfig } from "@/config";

// Application layouts
const { layouts } = appConfig;

/** Routes meta  */
const meta = { layout: layouts.app, requiresAuth: true };

/**
 * App routes
 */
const appRoutes = [
  {
    path: $paths.dashboard,
    name: "dashboard",
    meta,
    component: () => import("@/views/Dashboard.vue"),
  },
  {
    path: $paths.errors,
    name: "errors",
    meta,
    component: () => import("@/views/ErrorLogs.vue"),
  },
];

export default appRoutes;
